import { camelToSnakeCase } from '@/lib/helpers/utils.helpers'
import type { FilterType, FilterValueType } from '@/lib/types/common.types'

const filterKeysMap: Record<string, string> = {
  advertiser: 'advertiser_ids[]',
  advertiserGroup: 'advertiser_group_ids[]',
  advertiserGroupId: 'advertiser_group_id',
  targetUserId: 'target_user_id',
  creatorIds: 'creator_ids',
  campaignIds: 'campaign_ids',
}
const legacyFilterKeysMap: Record<string, string> = {
  advertiser: 'store_ids[]',
  advertiserGroup: 'store_group_ids[]',
  advertiserGroupId: 'store_group_id',
  storeGroup: 'storeGroup',
  userStatus: 'userStatus',
  legacyClientId: 'client',
}
const getServerPropertyKey = (key: string, isNewFilterMap = false) => {
  const keyMap = isNewFilterMap ? filterKeysMap : legacyFilterKeysMap
  if (keyMap[key]) {
    return keyMap[key]
  }

  return camelToSnakeCase(key)
}

const convertFilterValueIntoQueryString = (
  val: Exclude<FilterValueType, null | undefined | unknown[]>,
) => {
  if (typeof val === 'boolean') {
    return encodeURIComponent(val ? 1 : 0)
  }
  if (typeof val === 'object') {
    return encodeURIComponent(val.id)
  }

  return encodeURIComponent(val)
}

export const makeQueryString = (filter: FilterType, isNewFilterMap?: boolean): string | null => {
  const str = []

  for (const [key, value] of Object.entries(filter)) {
    if (Array.isArray(value)) {
      value.forEach((item) => {
        if (item !== undefined) {
          str.push(
            `${getServerPropertyKey(key, isNewFilterMap)}[]` +
              '=' +
              convertFilterValueIntoQueryString(item),
          )
        }
      })
    } else if (value !== undefined && value !== null) {
      str.push(
        getServerPropertyKey(key, isNewFilterMap) + '=' + convertFilterValueIntoQueryString(value),
      )

      if (key === 'query' && value && !Number.isNaN(Number(value))) {
        // eslint-disable-next-line @typescript-eslint/no-base-to-string, @typescript-eslint/restrict-template-expressions
        str.push(`or_id=${value}`)
      }
    }
  }

  if (str.length === 0) {
    return null
  }

  return str.join('&')
}

export const makeUrlWithParams = (apiUrl: string, params: Record<string, string>): string => {
  const paramsString = Object.keys(params).length
    ? new URLSearchParams(params).toString()
    : undefined
  return `${apiUrl}${paramsString ? `?${paramsString}` : ''}`
}

export const cleanUpUrl = (url?: string) => {
  if (!url) {
    return
  }

  if (url.includes('?') || url.includes('#')) {
    const [baseUrl] = url.split(/[?#]/)
    return baseUrl?.replace(/\/$/, '')
  } else {
    return url.replace(/\/$/, '')
  }
}
